const DEBUG_KEY = 'bjfun:debug'

export const isDebug = () => Boolean(localStorage.getItem(DEBUG_KEY))
export const setDebug = (debug: boolean) => {
    if (debug) localStorage.setItem(DEBUG_KEY, 'true')
    else localStorage.removeItem(DEBUG_KEY)
}

export const debug = createDebugger();

export function createDebugger(prefix?: string) {
    prefix ??= 'debug'
    prefix = '[' + prefix + ']'

    return {
        log: (...args: any[]) => {
            if (!isDebug()) return
            else if (prefix) console.log(prefix, ...args)
            else console.log(...args)
        },
        warn: (...args: any[]) => {
            if (!isDebug()) return
            else if (prefix) console.warn(prefix, ...args)
            else console.log(...args)
        },
        error: (...args: any[]) => {
            if (!isDebug()) return
            else if (prefix) console.error(prefix, ...args)
            else console.log(...args)
        },
        alert: (message: string) => {
            if (!isDebug()) return
            else if (prefix) alert(`${prefix} ${message}`)
            else alert(message)
        },
    };
}
